export default __webpack_public_path__ + "static/media/passportImage.05c7e2bf.png";